import api from "../../APIIntercepter";

async function submitBankSlipAPI(params) {
  const res = await api.post("/bankslip", params);
  return res.data;
}

async function getMyBankSlipsAPI(classId, status, date) {
  const res = await api.get(`/bankslip/${classId}/${status}/${date}`);
  return res.data;
}

export { submitBankSlipAPI, getMyBankSlipsAPI };
